import React from 'react';

import { connect } from 'react-redux';

import { LegacyAnalyticsInterface } from '@nerdwallet/calculator-onboarding-modal';
import { Box } from '@nerdwallet/currency';

import cityChange from '../../../../lib/actions/cityChange';
import { validationsSelector } from '../../../../lib/selectors';
import {
  manualInputsSelector,
  inputsSelector,
} from '../../../../lib/selectors/home-affordability-calculator-selectors';
import {
  RentVsBuyInput,
  INPUT_TRACKING_TYPES,
  debouncedTrackOnChange,
  BedrockInterface,
} from '../../../../lib/utils';
import LocationAutoComplete from '../../../location-autocomplete/location-autocomplete';

const LocationInput: React.FC<RentVsBuyInput> = ({
  manualInputs,
  inputs,
  dispatch,
  label,
  analytics,
  className,
}) => {
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (value) => {
    const { city, zip } = value;
    const trackingValue = `${city}${zip ? ` (${zip})` : ''}`;

    let legacy: LegacyAnalyticsInterface;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        inputType: INPUT_TRACKING_TYPES.TEXT,
      };
    }

    let bedrock: BedrockInterface;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_s',
      };
    }

    debouncedTrackOnChange({
      legacy,
      bedrock,
      validation: { valid: true },
      value: trackingValue,
    });

    dispatch(cityChange(value, 'purchaseAddress'));
  };

  return (
    <Box className={className}>
      <LocationAutoComplete
        data={manualInputs}
        enableTracking={false}
        label={label}
        key="hac-location-autocomplete"
        onChange={onInputChange}
        placeholder={`${inputs.purchaseAddress.city}, ${inputs.purchaseAddress.state}`}
        trackingFormName="onboarding"
      />
    </Box>
  );
};

const mapStateToProps = (state) => ({
  manualInputs: manualInputsSelector(state),
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(LocationInput);
